// Module
var code = "<md-menu-item> <md-button ng-click=\"$ctrl.TmrAboutModal()\" translate=\"HELPMENU.ABOUT\"></md-button> </md-menu-item> ";
// Exports
var _module_exports =code;;
var path = 'components/menus/helpMenu/helpMenu.content.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;